import { create } from 'zustand'

export enum SalaryRestrictionType {
  SignedOut = 'signedOut',
  MismatchedProfession = 'mismatchedProfession',
  Student = 'studentRestricted',
  Expired = 'accessExpired',
  OnboardingInProgress = 'onboardingInProgress',
  Employer = 'employerRestricted',
}

export enum SalaryForceLoginType {
  Pagination = 'pagination',
  Interaction = 'interaction',
}

export enum LoadingResults {
  Default,
  SortBy,
}

export interface SalaryTableStore {
  paginationDirection: PaginationDirection | null
  setPaginationDirection: (direction: PaginationDirection | null) => void
  hasInteractedWithRow: boolean
  setHasInteractedWithRow: (hasInteractedWithRow: boolean) => void
  publicInteractionCounter: number
  incrementPublicInteractionCounter: () => void
  salaryForceLoginType: SalaryForceLoginType | null
  setSalaryForceLoginType: (
    salaryForceLoginType: SalaryForceLoginType | null,
  ) => void
  hasShownForceLoginModal: boolean
  salaryRestriction: SalaryRestrictionType | null
  setSalaryRestriction: (
    salaryRestriction: SalaryRestrictionType | null,
  ) => void
  searchId: string | null
  setSearchId: (searchId: string | null) => void
  loadingResults: LoadingResults | null
  setLoadingResults: (loadingResults: LoadingResults | null) => void
}

export const useSalaryTableStore = create<SalaryTableStore>((set) => ({
  paginationDirection: null,
  setPaginationDirection: (paginationDirection: PaginationDirection | null) =>
    set(() => ({ paginationDirection })),
  hasInteractedWithRow: false,
  setHasInteractedWithRow: (hasInteractedWithRow: boolean) =>
    set(() => ({ hasInteractedWithRow })),
  // start at 1 to count first load of salaries
  publicInteractionCounter: 1,
  incrementPublicInteractionCounter: () =>
    set((state) => ({
      publicInteractionCounter: state.publicInteractionCounter + 1,
    })),
  salaryForceLoginType: null,
  setSalaryForceLoginType: (
    salaryForceLoginType: SalaryForceLoginType | null,
  ) =>
    set((state) => {
      // only show force modal login once when is by interaction
      const hasShownForceLoginModal =
        state.hasShownForceLoginModal ||
        salaryForceLoginType === SalaryForceLoginType.Interaction
      return {
        salaryForceLoginType,
        hasShownForceLoginModal,
      }
    }),
  hasShownForceLoginModal: false,
  salaryRestriction: null,
  setSalaryRestriction: (salaryRestriction: SalaryRestrictionType | null) =>
    set(() => ({ salaryRestriction })),
  searchId: null,
  setSearchId: (searchId: string | null) => set(() => ({ searchId })),
  salaryId: null,
  loadingResults: null,
  setLoadingResults: (loadingResults: LoadingResults | null) =>
    set(() => ({ loadingResults })),
}))

export enum PaginationDirection {
  Forward = 'forward',
  Backwards = 'backwards',
}
